<template>
  <!-- 車流推估人流 -->
  <div >
    <div class="d-flex justify-content-end">
      <button  class="btn btn-dia " @click="showModal()" style="" v-if="!isShortView">
        <i class="fas fa-search-plus"></i>
      </button>
    </div>

    <div id="chart" v-if="!showEmptyChart" >
      <!-- <div id="chart" > -->
      <apexchart
        type="pie"
        :options="chartOptions"
        :series="series"
        ref="chart"
        @legendClick="handleLegendClick"
      >
      </apexchart>
    </div>
    <div id="chart" v-if="showEmptyChart">
      <apexchart
        type="pie"
        :options="chartOptions2"
        :series="series2"
        ref="chart"
        @legendClick="handleLegendClick"

      >
      
      </apexchart>
    </div>

    
    <dialog-modal  id="popluarScenicAreaPop" ref="objectDetectionDetail" :showUpdateButton="false" :customUpdateButton="false" :modalSize="'xl'"
      :isImage="false" :isMarginAuto="false" :modalTitle="'車流推估人流'" :closeButton="false" >
    
      <div class="object-detection-detail  m-auto" >
        <div id="chartPop" v-if="!showEmptyChart" >
      <!-- <div id="chart" > -->
          <apexchart
            type="pie"
            :options="chartOptions"
            :series="series"
            ref="chartPop"
            
          >
          </apexchart>
        </div>
        <div id="chartPop"  v-if="showEmptyChart">
          <apexchart
            type="pie"
            :options="chartOptions2"
            :series="series2"
            ref="chartPop"
           
          >
          
          </apexchart>
        </div>
      </div>
    </dialog-modal>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import DialogModal from "./DialogModal.vue";
import MobileDetect from '../utils/mobileDetect'
import CONST from "../utils/const";
import Utils from "../utils/utils";
import { mapState, mapGetters } from "vuex";
import { postVehicleInTimeIntervalPerHour } from "../api/eastCoastDataApi/ElkQuery/VehicleElk";
const zh_tw = require("../utils/apexchartObject/apexLocales/zh-tw.json");

export default {
  components: {
    apexchart: VueApexCharts,DialogModal
  },

  data() {
    return {
      dataInterval: null,
      showEmptyChart: false,
      series: [],
      series2: [],
      viewPort: window.innerWidth,
      isShortView:false,
      chartOptions: {
        colors: CONST.APEXCHART_COLOR.SCENIC_AREA,
        chart: {
          defaultLocale: "zh-tw",
          locales: [zh_tw],
          type: "pie",
          // height: "300",

          toolbar: {
            show: true,
            tools: {
              download: true,
              pan: false,
              reset: false,
            },
            export: {
              svg: { filename: undefined },
              png: { filename: undefined },
              csv: { filename: undefined },
            },
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
          },
        },
        states: {
          hover: {
            filter: {
            type: 'none',
            }
          },
          active: {
            allowMultipleDataPointsSelection: true,
            filter: {
              type: "none",
              value: 0,
            },
          },
        },
        labels: [],
        dataLabels: {
          enabled: true,
         
        },
        legend: {
          position: "left",
          fontSize: "13px",
        },

        responsive: [
        {
            breakpoint: 480,
            options: {
              chart: {
                width: "90%",
              },
            },
          },
        
          {
            breakpoint: 380,
            options: {
              chart: {
                width: "100%",
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ],
        tooltip: {
          style: {
            fontSize: "18px",
          },
        },
      },

      chartOptions2: {
        colors: CONST.APEXCHART_COLOR.SCENIC_AREA,
        chart: {
          type: "pie",
          defaultLocale: "zh-tw",
          locales: [zh_tw],
          toolbar: {
            show: true,
            tools: {
              download: true,
              pan: false,
              reset: false,
            },
            export: {
              svg: { filename: undefined },
              png: { filename: undefined },
              csv: { filename: undefined },
            },
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
          },
        },
        states: {
          hover: {
            filter: {
            type: 'none',
            }
          },
          active: {
            allowMultipleDataPointsSelection: true,
            filter: {
              type: "none",
              value: 0,
            },
          },
        },
        labels: [],
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return "0";
          },
        },
        legend: {
          position: "left",
          fontSize: "13px",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "90%",
              },
            },
          },
          {
            breakpoint: 380,
            options: {
              chart: {
                width: "100%",
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ],
        tooltip: {
          style: {
            fontSize: "18px",
          },
          y: {
            formatter: function (
              value,
              { series, seriesIndex, dataPointIndex, w }
            ) {
              return 0;
            },
          },
        },
      },

      totalPeopleFlow: [],
      scenicAreaNameList: [],
      dailyParkingData: [],
    };
  },
  methods: {
    showModal(){
      this.$refs.objectDetectionDetail.openModal();
    },
    
    
   async searchPeopleFlow () {
      let condition = {
        areas: this.myScenicAreaList.map((s) => s.id),
        sttime:  moment().startOf("day").format(),
        endtime: moment().startOf("minute").format(), //取得當日最早時間與當下最近小時
        interval: "day",
      };
    
      let response = await postVehicleInTimeIntervalPerHour(condition);

      this.getDailyPeopleList(response.data);
    },
    async getDailyPeopleList(data) {    
      if((!this.myScenicAreaList)||this.myScenicAreaList.length==0 || (!data) || data.length==0) return ;
      // Utils.setScenicAreaNamebyId(data);
      const target = await data;

      this.dailyParkingData = await target;
      this.totalPeopleFlow =  this.dailyParkingData.map((d) => {
        return Math.round(d.totalPeopleFlow); //使用totalPeopleFlow作為車流推估人流資料來源
      });

      this.scenicAreaNameList = this.dailyParkingData.map((d) => {
        return d.areaName;
      });
      this.getChartData();

    },

    async getChartData() {

      //若this.totalPeopleFlow都不為0，則讓totalPeopleFlow中每個array都為10，並賦值給series2
      if (this.totalPeopleFlow.every((value) => value === 0)) {
        this.series2 = Array.from(
          { length: this.totalPeopleFlow.length },
          () => 10
          );
         
        this.chartOptions2.labels = this.scenicAreaNameList;
        this.chartOptions2.chart.toolbar.export.svg.filename = `車流推估人流_${moment().format(
          "YYYY年MM月DD日_HH時mm分"
        )}`;
        this.chartOptions2.chart.toolbar.export.csv.filename = `車流推估人流_${moment().format(
          "YYYY年MM月DD日_HH時mm分"
        )}`;
        this.chartOptions2.chart.toolbar.export.png.filename = `車流推估人流_${moment().format(
          "YYYY年MM月DD日_HH時mm分"
        )}`;
        this.$refs.chartPop.updateOptions(this.chartOptions2);
        this.$refs.chart.updateOptions(this.chartOptions2);

      }
        this.chartOptions.labels = this.scenicAreaNameList;
        this.series = this.totalPeopleFlow;
        this.chartOptions.chart.toolbar.export.svg.filename = `車流推估人流_${moment().format(
          "YYYY年MM月DD日_HH時mm分"
        )}`;
        this.chartOptions.chart.toolbar.export.csv.filename = `車流推估人流_${moment().format(
          "YYYY年MM月DD日_HH時mm分"
        )}`;
        this.chartOptions.chart.toolbar.export.png.filename = `車流推估人流_${moment().format(
          "YYYY年MM月DD日_HH時mm分"
        )}`;
        //  refresh apexchart labels
 
        this.$refs.chart.updateOptions(this.series);
        this.$refs.chart.updateOptions(this.chartOptions);
        this.$refs.chartPop.updateOptions(this.chartOptions);


    },

    async handleLegendClick(event, chartContext, config) {
      const clickedLegend = config.config.labels; //labels Array
      const legendIndex = chartContext; //點選labels的 index

      const targetItem = await this.myScenicAreaList.find(
        (item) => item.name === clickedLegend[legendIndex]
      );
      if (targetItem) {
        this.$router.push(`/scenicAreaInfo?id=${targetItem.id}`);
      } else {
        return;
      }
    },
  },
  computed: {
    ...mapGetters("scenicArea", { myScenicAreaList: "getMyScenicArea" }),

    // dailyParkingList() {
    //   return this.$store.getters["elasticMonitor/getVehicleAndPeople"];
    // },
  },

  watch: {
    //判斷series若為0，則改顯示series2的資料
    series: {
      // immediate: true,
      async handler(newVal) {
        if (newVal.every((value) => value === 0)) {
          this.showEmptyChart = true;
        } else {
          this.showEmptyChart = false;
        }
      },
    },

    // dailyParkingList: {
    //   async handler(newVal) {
    //      this.getDailyPeopleList();
      

    //   },
    // },

    // myScenicAreaList: {
    //   async handler(newVal) {
    //     // this.getDailyPeopleList();
    //   },
    // },

    async myScenicAreaList(newData, oldData) {
      if (newData !== oldData) {
      //  this.getDailyPeopleList();
        await this.searchPeopleFlow();
      }
    },

    

    viewPort:{
      handler(newVal){
        if(newVal < 600){
        this.isShortView = true;
      }else{
        this.isShortView = false;
      }},
      immediate: true
    },

  },

  async mounted() {
    if(this.myScenicAreaList) await this.searchPeopleFlow() ;
    this.$_resizeEventHandler = () => {
      this.viewPort = window.innerWidth;
    };
    window.addEventListener('resize', this.$_resizeEventHandler);
    this.dataInterval = setInterval(async () => {
      await this.getDailyPeopleList();
       this.getChartData(); //為了更新每次export的檔案時間
    }, CONST.REFRESH_DAT_TIMER_MIN);
  },

  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval);
    this.dataInterval = null;
  },
};
</script>

<style  lang="scss" scoped >


#chart {
  max-width: 450px;
  margin: 0 auto;
}

.chart-dialog {
  max-width: 55vw !important;
  margin: 0 auto;
}
// .apexcharts-datalabels{
//   opacity: 1 !important;
// }


.btn-dia{
  // display: block;
  color:rgb(98, 97, 97);
  margin-right: 0;
}

</style>